var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"play",staticClass:"play"},[_c('div',{staticClass:"x-right-close close el-icon-close",on:{"click":_vm.close}})])}
var staticRenderFns = []

export { render, staticRenderFns }